export default __webpack_public_path__ + "static/media/pdf.232017c4.svg";